<div class="order-summary">
  <!-- Cabeçalho -->
  <header class="order-summary__header">
    <div class="header-content">
      <umkt-icon [icon]="{ name: 'carrinho', type: 'mondrian-icons' }" size="md"></umkt-icon>
      <h2 class="header-title">{{ 'pages.orderSummaryCard.title' | i18n }}</h2>
    </div>
  </header>

  <!-- Cupom de desconto -->
  <!-- <div class="coupon-section" *ngIf="checkoutArea">
    <div class="coupon-input-wrapper" *ngIf="!showCouponInput && !isCouponApplied" (click)="showCouponForm()">
      <umkt-icon [icon]="{ name: 'cupom', type: 'mondrian-icons' }" size="md"></umkt-icon>
      <span class="coupon-text">Possui um cupom de desconto?</span>
      <umkt-icon [icon]="{ name: 'bi bi-chevron-right', type: 'bootstrap-icons' }" size="md"></umkt-icon>
    </div>
    
    <div class="coupon-form" *ngIf="showCouponInput && !isCouponApplied">
      <ustore-input
        id="cupom"
        [ariaLabel]="'Cupom de desconto'"
        [placeholder]="'Digite seu cupom'"
        [(ngModel)]="discountCoupon"
        [clearable]="false"
        [iconAction]="{ name: 'bi bi-check-lg', type: 'bootstrap-icons', size: 'medium', position: 'right', color: '#DA291C' }"
        (iconActionClick)="applyCoupon()"
      ></ustore-input>
    </div>
    
    <div class="coupon-applied" *ngIf="isCouponApplied">
      <span class="coupon-code">{{ discountCoupon }}</span>
      <span class="discount-value">-R$ {{ discountValue | currencyBRL }}</span>
      <button class="remove-coupon-btn" (click)="removeCoupon()">
        <umkt-icon [icon]="{ name: 'bi bi-x-lg', type: 'bootstrap-icons' }" size="sm"></umkt-icon>
      </button>
    </div>
  </div> -->

  <!-- Lista de produtos -->
  <div class="products-section">
    <umkt-cart-product-list
      [products]="(products$ | async) ?? []"
      [maxQuantityByPlanId]="maxQuantityByPlanId"
      (removePlan)="onRemovePlan($event)"
      (changeQty)="onChangeQty($event)"
      [showProductTerm]="true"
    >
    </umkt-cart-product-list>
  </div>

  <!-- Itens gratuitos -->
  <div class="free-items-section">
    <div class="free-item">
      <span class="free-item-label">{{ 'pages.orderSummaryCard.freeItems.installation' | i18n }}</span>
      <span class="free-item-value">{{ 'pages.orderSummaryCard.freeItems.free' | i18n }}</span>
    </div>
    <div class="free-item">
      <span class="free-item-label">{{ 'pages.orderSummaryCard.freeItems.membership' | i18n }}</span>
      <span class="free-item-value">{{ 'pages.orderSummaryCard.freeItems.free' | i18n }}</span>
    </div>
  </div>

  <!-- Total -->
  <div class="total-section font-highlight" [class.total-section--registry]="showRegistrySplit">
    @if (showRegistrySplit) {
      <div class="registry-total">
        <div class="registry-total__price">
          <span>{{ 'pages.orderSummaryCard.totalLabel' | i18n }}</span>
          <span>{{ firstMonthTotal | currencyBRL }}</span>
        </div>
        <p class="registry-total__caption">
          @if (monthlyTotalValue > 0) {
            {{ 'components.cart.registryTotalCaption' | i18n: { price: (monthlyTotalValue | currencyBRL:false) } }}
          } @else {
            {{ 'components.cart.registryTotalCaptionOnce' | i18n }}
          }
        </p>
      </div>
    } @else {
      <span class="total-label">{{ 'pages.orderSummaryCard.totalLabel' | i18n }}</span>
      @if (!useValidatedOrderTotal && (showAnnualTotal || showMonthlyTotal)) {
        <div class="total-values">
          @if (showMonthlyTotal) {
            <div class="total-value">
              <span class="currency">R$</span>
              <span class="amount">{{ monthlyTotalValue | currencyBRL:false }}</span>
              <span class="period">{{ 'pages.orderSummaryCard.period' | i18n }}</span>
            </div>
          }
          @if (showAnnualTotal) {
            <div class="total-value">
              <span class="currency">R$</span>
              <span class="amount">{{ annualTotalValue | currencyBRL:false }}</span>
              <span class="period">{{ 'pages.orderSummaryCard.periodAnnual' | i18n }}</span>
            </div>
          }
        </div>
      } @else {
        <div class="total-value total-value--single">
          <span class="currency">R$</span>
          <span class="amount">{{ totalValue | currencyBRL:false }}</span>
        </div>
      }
    }
  </div>
</div>